export default {
  invalidData: {
    name: 'invalid-data',
    types: {
      restaurantId: 'restaurant-id',
    },
  },
}
